import React from 'react'
import styled from 'styled-components'
import { space, colors, radius } from 'theme'
import { Box, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import Link from 'components/Link'
import logo from 'static/logo/logo.png'
import Button from 'components/Button'

const StyledFlex = styled(Flex)`
  padding: 0 0 ${space.m} 0;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 238px;
`

const StyledImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
`

const ExpertJoinCard = () => (
  <Box my="l">
    <StyledFlex>
      <Box width="80px" height="80px" mb="xs">
        <StyledImage src={logo} alt="Agency Vista" />
      </Box>
      <Box mb="s" mt="m" width="180px">
        <Text lineHeight="18px" mx="xs" fontSize="s">
          Do you want to join our experts program?
        </Text>
      </Box>
      <Box mt="l" width="100%">
        <Button.Primary as={Link} href="mailto:yourfriends@agencyvista.com" width="100%" fontSize="s">
          Get in touch
        </Button.Primary>
      </Box>
    </StyledFlex>
  </Box>
)

export default ExpertJoinCard
